export const areInterfaceSettingsInitialisedSelector = (state) =>
    state.getIn(['app', 'interfaceSettings', 'initialised']);

export const areDnd3dEffectsEnabledSelector = (state) =>
    state.getIn(['app', 'interfaceSettings', 'enableDnd3dEffects']);
